
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class IssueMaterialItemsDialog extends Serenity.EntityDialog<IssueMaterialItemsRow, any> {
        protected getFormKey() { return IssueMaterialItemsForm.formKey; }
        protected getIdProperty() { return IssueMaterialItemsRow.idProperty; }
        protected getLocalTextPrefix() { return IssueMaterialItemsRow.localTextPrefix; }
        protected getNameProperty() { return IssueMaterialItemsRow.nameProperty; }
        protected getService() { return IssueMaterialItemsService.baseUrl; }
        protected getDeletePermission() { return IssueMaterialItemsRow.deletePermission; }
        protected getInsertPermission() { return IssueMaterialItemsRow.insertPermission; }
        protected getUpdatePermission() { return IssueMaterialItemsRow.updatePermission; }

        protected form = new IssueMaterialItemsForm(this.idPrefix);

    }
}